export { default } from './ProductList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductList/index.js